/**
 * Rising Auctions — shared cart line item properties + basket id cache.
 * Depends on theme.liquid: data-ra-cart-token on <body> (Liquid cart.token).
 * cart_token cart attribute is synced from cart.token via theme cart-token-sync (cart-icon / cart page).
 * Load before rising-auctions-pdp.js, -plp.js, -actions.js, -history.js.
 */
(function () {
  'use strict';

  function parseBasketId(token) {
    if (token == null || token === '') return '';
    var t = String(token).trim();
    var gidMatch = t.match(/^gid:\/\/shopify\/Cart\/(.+)$/);
    if (gidMatch) return gidMatch[1];
    if (t.indexOf('?key=') !== -1) {
      var parts = t.split('?key=');
      return (parts[1] || parts[0] || '').trim();
    }
    return t;
  }

  var RA = window.RA || {};
  window.RA = RA;

  function setBasketIdFromToken(token) {
    var id = parseBasketId(token);
    if (id) RA.basketId = id;
    return id;
  }

  RA.refreshCart = function () {
    var sharedFetch = window.TJC && window.TJC.fetchCartJson;
    var fetchCart = typeof sharedFetch === 'function'
      ? sharedFetch()
      : fetch('/cart.js', { credentials: 'include' }).then(function (r) {
          return r.json();
        });

    return fetchCart
      .then(function (cart) {
        var tok = cart && cart.token;
        setBasketIdFromToken(tok);
        return RA.basketId || '';
      });
  };

  RA.syncCartTokenAfterAdd = function () {
    return RA.refreshCart().catch(function (error) {
      console.error('[RA] Failed to refresh basket id after add', error);
      return RA.basketId || '';
    });
  };

  /** Resolve basket id for line item properties: cache, body data-ra-cart-token, or /cart.js */
  RA.ensureBasketId = function () {
    if (RA.basketId) return Promise.resolve(RA.basketId);
    var body = document.body;
    if (body) {
      var raw = body.getAttribute('data-ra-cart-token');
      if (raw && setBasketIdFromToken(raw)) return Promise.resolve(RA.basketId);
    }
    return RA.refreshCart();
  };

  var AMS_CART_FIELDS_INCOMPLETE_MSG =
    "We couldn't add this auction to your bag because product details are incomplete. Please refresh the page or try again later.";

  /** Returns { ok: true } or { ok: false, message: string }. */
  RA.validateAmsCartFieldsForAdd = function (opts) {
    opts = opts || {};
    var amsAuctionCode = String(opts.amsAuctionCode != null ? opts.amsAuctionCode : '').trim();
    var auctionId = String(opts.auctionId != null ? opts.auctionId : '').trim();
    var raMain = String(opts.raMainProductCode != null ? opts.raMainProductCode : '').trim();
    if (!amsAuctionCode || !raMain || !auctionId) {
      return { ok: false, message: AMS_CART_FIELDS_INCOMPLETE_MSG };
    }
    return { ok: true };
  };

  /** Fire-and-forget report to app proxy for Log Center (never blocks UI). */
  RA.reportMissingAmsCartFields = function (payload) {
    payload = payload || {};
    var params = new URLSearchParams();
    if (payload.auctionId) params.set('auctionId', String(payload.auctionId));
    if (payload.source) params.set('source', String(payload.source));
    if (payload.amsAuctionCode != null) params.set('amsAuctionCode', String(payload.amsAuctionCode));
    if (payload.raMainProductCode != null) params.set('mainProductCode', String(payload.raMainProductCode));
    fetch('/apps/rising-auctions/ams-cart-props-issue?' + params.toString(), {
      credentials: 'include'
    }).catch(function () {});
  };

  /** Line item properties for /cart/add.js (all string values). */
  RA.buildLineItemProperties = function (opts) {
    opts = opts || {};
    var amsAuctionCode = String(opts.amsAuctionCode != null ? opts.amsAuctionCode : '');
    var auctionId = String(opts.auctionId != null ? opts.auctionId : '');
    return {
      _raAuctionCode: auctionId,
      _auctionCode: amsAuctionCode,
      _raSKU: String(opts.variantSku != null ? opts.variantSku : ''),
      _raBasePrice: String(opts.basePrice != null ? opts.basePrice : ''),
      _basketID: String(opts.basketId != null ? opts.basketId : ''),
      _itemSource: 'RISING',
      _raMainProductCode: String(opts.raMainProductCode != null ? opts.raMainProductCode : ''),
      _paymentExpirationAt: String(opts.paymentExpirationAt != null ? opts.paymentExpirationAt : '')
    };
  };

  function bootstrapFromBody() {
    var body = document.body;
    if (!body) return;
    var raw = body.getAttribute('data-ra-cart-token');
    if (raw) setBasketIdFromToken(raw);
  }

  /** After cart changes, refresh basketId from /cart.js for line item properties. */
  var refreshCartTimer = null;
  function onCartEvent(event) {
    var cart = event && event.detail && event.detail.resource;
    if (cart && cart.token) {
      setBasketIdFromToken(cart.token);
      return;
    }
    if (refreshCartTimer) return;
    refreshCartTimer = setTimeout(function () {
      refreshCartTimer = null;
      RA.refreshCart().catch(function () {});
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapFromBody);
  } else {
    bootstrapFromBody();
  }

  document.addEventListener('cart:updated', onCartEvent);
  document.addEventListener('cart:update', onCartEvent);
})();
